// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

// TODO: Set this up to the proper T-Navigator auth
const generateHeaders = (locale, Authorization) => ({
  Accept: 'application/vnd.intrepid+json; version=2',
  'Accept-Language': locale,
  'Content-Type': 'application/json',
  Authorization
});

// TODO: Integrate with country dropdown component
export const getAlertsByCountry = (locale, auth, country_code) =>
  fetch(
    `${window.config.REACT_APP_BASE_URL}/api/travelnavigator/country/${country_code}/alert/?page=1&limit=25`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/alerts.js